module.exports = __webpack_public_path__ + "static/media/elo.5c82e7d3.svg";